// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3GjS9","amount":"Amount_amount__1fxEm","tip":"Amount_tip__3adm1","tipHeader":"Amount_tipHeader__2FGJs","tipsWrap":"Amount_tipsWrap__3Puiz"};